export default "{\n    \"toolTips\": {\n        \"suggestUpgrade\": \"Améliorez votre plan pour accéder à cette fonctionnalité\"\n    }\n}\n"